// Auto-generated component
import React,{useState,useEffect} from "react";

export const settings = {
  "backgroundColor": "#FF0",
  "width": "50",
  "numberInput": "0",
  "title": "Başlık",
  "logo_aligment": "left",
  "vertical_alignment": "middle",
  "vertical_alignment2": "middle",
  "Text Alanı": "middle",
  "textAlignment": "center"
};

export default function Comp_page1_1(props) {
  return (
<div style={{ backgroundColor: props?.settings?.backgroundColor?.value, width: props?.settings?.width?.value, height: props?.settings?.height?.value }}>
								<h1 style={{ textAlign: props?.settings?.textAlignment?.value }}>{props?.settings?.title?.value}-aaaa</h1>
							</div>
  );
}
